export enum FeedbackType {
  CONNECTION_ISSUE = 'connection-issue',
  ERROR = 'error',
  INFORM = 'inform',
  SUCCESS = 'success',
  CUSTOM = 'custom',
}
